import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";

import { bookingService } from "../../services/bookingService";
import { useDispatch, useSelector } from "react-redux";
import "./bookingDetailModal.css";
import BookingCancelModal from "./bookingCancelModal";
import {
  formatDate,
  formattedDateTime,
  formatPrice,
  statusBookingClassName,
} from "../../Helpers/BaseHelper";
import { fetchFeedbackByTourId } from "@/redux/slices/feedbackSlice";
import { useNavigate } from "react-router-dom";
const BookingDetailModal = ({
  show,
  onClose,
  bookingId,
  userInfo,
  isCancelled,
  setIsCancelled,
}) => {
  const dispatch = useDispatch();
  const [booking, setBooking] = useState(null);
  const { feedbacks, averageRating } = useSelector((state) => state.feedback);

  const navigate = useNavigate();
  const [showCancelModal, setShowCancelModal] = useState(false);
  useEffect(() => {
    const fetchBooking = async () => {
      try {
        const data = await bookingService.getBookingById(bookingId || 2);
        console.log(data.data, "dataBooking");
        setBooking(data.data);
      } catch (err) {
        console.log(bookingId, "bookingId");
      }
    };

    fetchBooking();
  }, [bookingId]);

  useEffect(() => {
    if (booking) {
      dispatch(fetchFeedbackByTourId(booking.tourId));
    }
  }, [dispatch, booking]);

  if (bookingId === 0 || !userInfo) return null;

  const isCancelable = (startDateStr) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // reset về đầu ngày

    const startDate = new Date(startDateStr);
    startDate.setHours(0, 0, 0, 0); // reset về đầu ngày

    const diffInTime = startDate - today;
    const diffInDays = diffInTime / (1000 * 60 * 60 * 24);
    return diffInDays > 1;
  };

  const renderFooterButtons = () => {
    if (booking.status === "Pending") {
      return (
        <Button variant="secondary" onClick={onClose}>
          Đóng
        </Button>
      );
    }

    if (booking.status === "Upcoming") {
      if (isCancelable(booking.startDate)) {
        return (
          <Button
            variant="primary"
            onClick={() => {
              onClose();
              setShowCancelModal(true);
            }}
          >
            Huỷ đặt tour
          </Button>
        );
      } else {
        return (
          <Button variant="secondary" onClick={onClose}>
            Đóng
          </Button>
        );
      }
    }

    if (booking.status === "Cancelled" || booking.status === "Completed") {
      return (
        <Button
          variant="secondary"
          onClick={() => navigate(`/tour-detail/${booking.tourId}`)}
        >
          Đặt lại tour
        </Button>
      );
    }

    return (
      <Button variant="secondary" onClick={onClose}>
        Đóng
      </Button>
    );
  };

  return (
    <>
      <Modal show={show} onHide={onClose} centered size="xl">
        {booking && (
          <>
            <Modal.Header closeButton>
              <Modal.Title>
                Booking Info{" "}
                <span className="fs-14 fw-medium text-primary">
                  #{bookingId}
                </span>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <div className="upcoming-content">
                <div className="upcoming-title mb-4 d-flex align-items-center justify-content-between p-3 rounded">
                  <div className="d-flex align-items-center flex-wrap">
                    <div className="me-2">
                      <img
                        src={booking.tourResponse.imageUrls?.[0]}
                        alt="Tour"
                        className="avatar avatar-md avatar-rounded"
                      />
                    </div>
                    <div>
                      <h6 className="mb-1">{booking.tourName}</h6>
                      <div className="title-list">
                        <p className="d-flex align-items-center pe-2 me-2 border-end border-light fw-normal">
                          <i className="isax isax-signpost5 me-2"></i>
                          {booking.tourResponse.categoryName}
                        </p>
                        <p className="d-flex align-items-center pe-2 me-2 border-end border-light fw-normal">
                          <i className="isax isax-location5 me-2"></i>
                          {booking.tourResponse.departureLocation}
                        </p>
                        <p className="d-flex align-items-center pe-2 me-2 fw-normal">
                          <span className="badge badge-warning badge-xs text-gray-9 fs-13 fw-medium me-2">
                            {averageRating || 5.0}
                          </span>
                          ({feedbacks.length} Reviews)
                        </p>
                      </div>
                    </div>
                  </div>
                  <div>
                    <span
                      className={`badge ${statusBookingClassName(
                        booking.status
                      )} rounded-pill d-inline-flex align-items-center fs-10`}
                    >
                      <i className="fa-solid fa-circle fs-5 me-1"></i>
                      {booking.status}
                    </span>
                  </div>
                </div>

                <div className="upcoming-details">
                  <h6 className="mb-2">Thông tin đặt tour</h6>
                  <div className="row gy-3">
                    <div className="col-lg-3">
                      <h6 className="fs-14">Nơi khởi hành</h6>
                      <p className="text-gray-6 fs-16">
                        {booking.tourResponse.departureLocation}
                      </p>
                    </div>
                    <div className="col-lg-3">
                      <h6 className="fs-14">Số ngày</h6>
                      <p className="text-gray-6 fs-16">
                        {booking.tourResponse.numberDay}
                      </p>
                    </div>
                    <div className="col-lg-3">
                      <h6 className="fs-14">Đặt vào lúc</h6>
                      <p className="text-gray-6 fs-16">
                        {formatDate(booking.bookingDate)}
                      </p>
                    </div>
                    <div className="col-lg-3">
                      <h6 className="fs-14">Ngày bắt đầu</h6>
                      <p className="text-gray-6 fs-16">
                        {formattedDateTime(booking.startDate)}
                      </p>
                    </div>
                    <div className="col-lg-3">
                      <h6 className="fs-14">Ngày kết thúc</h6>
                      <p className="text-gray-6 fs-16">
                        {formattedDateTime(booking.endDate)}
                      </p>
                    </div>
                    <div className="col-lg-3">
                      <h6 className="fs-14">Số người</h6>
                      <p className="text-gray-6 fs-16">{booking.quantity}</p>
                    </div>
                  </div>
                </div>

                <div className="upcoming-details">
                  <h6 className="mb-2">Thông tin người thanh toán</h6>
                  <div className="row gy-3">
                    <div className="col-lg-3">
                      <h6 className="fs-14">Tên</h6>
                      <p className="text-gray-6 fs-16">{userInfo.fullName}</p>
                    </div>
                    <div className="col-lg-3">
                      <h6 className="fs-14">Email</h6>
                      <p className="text-gray-6 fs-16">{userInfo.email}</p>
                    </div>
                    <div className="col-lg-3">
                      <h6 className="fs-14">Điện thoại</h6>
                      <p className="text-gray-6 fs-16">
                        {userInfo.phoneNumber}
                      </p>
                    </div>
                    <div className="col-lg-3">
                      <h6 className="fs-14">Địa chỉ</h6>
                      <p className="text-gray-6 fs-16">{userInfo.address}</p>
                    </div>
                  </div>
                </div>
                <div class="upcoming-details">
                  <h6 class="mb-2">Thông tin thanh toán</h6>
                  <div class="row gy-3">
                    <div class="col-lg-3">
                      <h6 class="fs-14">Id thanh toán</h6>
                      <p class="text-primary fs-16 ">
                        #{booking.paymentResponse.paymentId}
                      </p>
                    </div>
                    <div class="col-lg-3">
                      <h6 class="fs-14">Phương thức thanh toán</h6>
                      <p class="text-gray-6 fs-16 ">
                        {booking.paymentResponse.paymentMethod}
                      </p>
                    </div>
                    <div class="col-lg-3">
                      <h6 class="fs-14">Trạng thái thanh toán</h6>
                      <p class="text-success fs-16 ">
                        {booking.paymentResponse.status}
                      </p>
                    </div>
                    <div class="col-lg-3">
                      <h6 class="fs-14">Ngày thanh toán</h6>
                      <p class="text-gray-6 fs-16 ">
                        {" "}
                        {formattedDateTime(booking.paymentResponse.paymentDate)}
                      </p>
                    </div>
                    <div class="col-lg-3">
                      <h6 class="fs-14">Thuế</h6>
                      <p class="text-gray-6 fs-16 ">0% ({formatPrice(0)})</p>
                    </div>
                    <div class="col-lg-3">
                      <h6 class="fs-14">Giảm giá</h6>
                      <p class="text-gray-6 fs-16 ">
                        {booking.discountDTO
                          ? `${
                              booking.discountDTO.discountPercentage
                            }% (${formatPrice(
                              (booking.paymentResponse.amount /
                                (1 - booking.discountDTO.discountPercentage)) *
                                -1
                            )})`
                          : `0% (${formatPrice(0)})`}
                      </p>
                    </div>
                    <div class="col-lg-3">
                      <h6 class="fs-14">Chi phí đặt tour</h6>
                      <p class="text-gray-6 fs-16 ">
                        {booking.discountDTO
                          ? formatPrice(
                              booking.paymentResponse.amount /
                                (1 -
                                  booking.discountDTO.discountPercentage / 100)
                            )
                          : formatPrice(booking.paymentResponse.amount)}
                      </p>
                    </div>
                    <div class="col-lg-3">
                      <h6 class="fs-14">Tổng số tiền đã thanh toán</h6>
                      <p class="text-gray-6 fs-16 ">
                        {formatPrice(booking.paymentResponse.amount)}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Modal.Body>

            <Modal.Footer>{renderFooterButtons()}</Modal.Footer>
          </>
        )}
      </Modal>
      <BookingCancelModal
        show={showCancelModal}
        onHide={() => setShowCancelModal(false)}
        bookingId={bookingId}
        isCancelled={isCancelled}
        setIsCancelled={setIsCancelled}
      />
    </>
  );
};

export default BookingDetailModal;
